<template>
 <pageLayout>
    <div class="image-wrapper" v-for="(img, index) in imgs" :key="index">
      <img :src="img" />
    </div>
 </pageLayout>
</template>

<script>
import pageLayout from '@/components/layout'
export default {
  name: 'home',
  components: {
    pageLayout
  },
  data () {
    return {
      imgs: [
        'https://cookhere-images.oss-cn-shenzhen.aliyuncs.com/202105/home/2_1.png',
        'https://cookhere-images.oss-cn-shenzhen.aliyuncs.com/202105/home/3.png',
        'https://cookhere-images.oss-cn-shenzhen.aliyuncs.com/202105/home/4.png',
        'https://cookhere-images.oss-cn-shenzhen.aliyuncs.com/202105/home/5.png'
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.image-wrapper {
  img {
    width: 100%;
    height: auto;
  }
}
</style>
